module.exports = __webpack_public_path__ + "static/images/components/BattleWizard/components/Option/images/players.0116e941.png";


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/Option/images/players.png
// module id = 2522
// module chunks = 11